import { MESSAGE_TEMPLATE_CONFIGS, type MessageTemplateType } from "./types";

/**
 * Signed minute offset from a parent timeline step's scheduled time to when the
 * message should fire. "before" placement (e.g. reminder) uses a negative offset.
 * Used by template instantiation and when re-syncing message dates after edits.
 */
export function getMessageTemplateOffsetMinutes(step: {
  messageType?: MessageTemplateType;
  minutesAfterPrevious?: number;
}): number {
  const minutes = step.minutesAfterPrevious ?? 0;
  const config = MESSAGE_TEMPLATE_CONFIGS.find(
    (c) => c.type === step.messageType,
  );
  return config?.placement === "before" ? -minutes : minutes;
}
